import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  FormControlLabel,
  Grid,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import {
  getData,
  storeData,
  checkEditPage,
  getAllStorage,
} from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import { isMobile } from "react-device-detect";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import DialogWait from "../../components/CustomDialog/DialogWait";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import { isEmpty, flatMap, chain, map, filter } from "lodash";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import clsx from "clsx";
import qs from "qs";
import InfoIcon from "@mui/icons-material/Info";
import ProductsType from "../../components/CustomDialog/ProductsType";
import { bundleProduct } from "./bundleproduct";

const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const ProductsChoice = (props) => {
  const mb = isMobile ? 16 : 9;
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const translations = getData("Translations");
  const [lang, setLang] = useState(getData("lang"));
  const [isLoading, setIsLoading] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const [products, setProducts] = useState([]);
  const [expanded, setExpanded] = useState("");
  const [dataJson, setDataJson] = useState([]);
  const [isCheck, setIsCheck] = useState(false);
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const career = getData("f3_career");
  let snapIdCard = getData("uploadImage");

  const [isType, setIsType] = useState(false);
  const checkJumpPage = async () => {
    await getImage();
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const callProductManp = async () => {
    try {
      setIsLoading(true);
      const body = {
        head_token,
        product_json: [...dataJson],
      };
      let isValid = true;
      const findGTokenSelected = dataJson.some((item) => item.id === 59);
      if (findGTokenSelected) {
        const res = await checkGtokenAccount(products);
        if (!res) {
          let mss =
            "เนื่องจากท่านเคยเปิดบัญชีหรืออยู่ระหว่างดำเนินการเปิดบัญชี G-Token <br>กรุณาตรวจสอบผลิตภัณฑ์ก่อนเปิดบัญชี <br><br>หากมีข้อสงสัยสามารถติดต่อ DAOL Contact Center 0 2351 1800 เพื่อสอบถามข้อมูลเพิ่มเติม";
          setIsModelWaitText({
            title: "ขออภัยท่านไม่สามารถเปิดบัญชี G-Token ได้",
            massage: mss,
            btn: "กลับ",
          });
          isValid = false;
        }
        setIsLoading(false);
      }

      if (isValid) {
        await GlobalApi.post(`${Configs.baseAPIURL03}/form/product/manp`, body)
          .then((res) => {
            if (res?.status === API_CODE_SUCCESS) {
              //TODO comback
              // if (editUrl) {
              //   storeData("editPage", "product_choice");
              //   props.history.push("/summary");
              // } else {
              saveComeback();
              // }
            } else {
              setIsModelWaitText({
                title: "เกิดข้อผิดพลาด",
                massage: res.response?.data?.Data?.[0]?.[0]?.MsgDesc
                  ? res.response?.data?.Data?.[0]?.[0]?.MsgDesc
                  : res,
                btn: "กลับ",
              });
            }
            setIsLoading(false);
          })
          .catch((e) => {
            if (!e.response) {
              setIsModelWaitText({
                title: "เกิดข้อผิดพลาด",
                massage: "กรุณาทำรายการใหม่อีกครั้ง",
                btn: "กลับ",
              });
            } else {
              setIsModelWaitText({
                title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
                massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
                btn: "กลับ",
              });
            }
            setIsLoading(false);
          });
      }
    } catch (error) {
      if (!error.response) {
        setIsModelWaitText({
          title: "เกิดข้อผิดพลาด",
          massage: "กรุณาทำรายการใหม่อีกครั้ง",
          btn: "กลับ",
        });
      } else {
        setIsModelWaitText({
          title: error.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
          massage: error.response.data?.Data?.[0]?.[0]?.MsgDesc,
          btn: "กลับ",
        });
      }
      setIsLoading(false);
    }
  };
  const saveComeback = async () => {
    storeData("stamp_page", "SUIT");
    var last_stamp = JSON.stringify(await getAllStorage("SUIT"));
    const saveData = [
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUIT",
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(
        saveData[0].url,
        qs.stringify(saveData[0].postData),
        header,
      )
        .then((res) => {
          setIsLoading(false);
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            setIsLoading(false);
            setIsModelWaitText({
              title: "เกิดข้อผิดพลาด",
              massage: mss,
              btn: "กลับ",
            });
          } else {
            // console.log("save" + saveData[0].name + "  success");
            // checkEditPage().then((res) => {
            //   if (res) {
            //     storeData("editPage", "product_choice");
            //     props.history.push("/summary");
            //   } else {
            props.history.push("/suit");
            //   }
            // });
          }
        })
        .catch((er) => {
          // console.log(er);
          // console.log("save " + saveData[0].name + "  error");
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModelWaitText({
            title: title,
            massage: mss,
            btn: "กลับ",
          });
        });
    } catch (error) {
      // console.log(error);
      // console.log("catch" + saveData[0].name + "  error");
      setIsLoading(false);
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage:
          "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
          getData("api_error")?.message +
          ")",
        btn: "กลับ",
      });
    }
  };
  const handleNext = () => {
    //TODO function nextPage
    callProductManp();
  };
  const callChoice = async () => {
    setIsLoading(true);
    const header = {
      headers: {
        Accept: "application/json",
      },
    };

    try {
      let productLicenseList = [];

      if (checkuserinfo) {
        try {
          const licenseRes = await GlobalApi.post(
            `${Configs.baseAPIURL03}/form/ic_license_product/selbyhead`,
            {
              head_token: head_token,
              aeCode: checkuserinfo.aeCode ? checkuserinfo.aeCode : "default",
            },
            header,
          );

          if (
            licenseRes.status === API_CODE_SUCCESS &&
            licenseRes?.data?.data?.saFormProductList
          ) {
            productLicenseList = licenseRes.data.data.saFormProductList;
          }
        } catch (err) {
          console.info("error ic license : ", err);
        }
      }

      try {
        const productRes = await GlobalApi.post(
          `${Configs.baseAPIURL03}/form/product/selbyhead`,
          { head_token: head_token },
          header,
        );

        if (productRes.status === API_CODE_SUCCESS) {
          const productDisplayList = productRes.data?.Data;
          const newProductList = productDisplayList.map((groupItem) => {
            const filteredItems = groupItem.items.filter((item) =>
              productLicenseList.includes(item.id.toString()),
            );
            return {
              group: groupItem.group,
              items: filteredItems,
            };
          });

          setProducts(newProductList); // ✅ set state
          setIsLoading(false);
          return newProductList; // ✅ return สำเร็จแล้ว
        } else {
          setIsModelWaitText({
            title: "เกิดข้อผิดพลาด",
            massage: productRes,
            btn: "กลับ",
          });
          setIsLoading(false);
          return []; // กรณี error
        }
      } catch (er) {
        setIsModelWaitText({
          title: "เกิดข้อผิดพลาด",
          massage: er,
          btn: "กลับ",
        });
        setIsLoading(false);
        return [];
      }
    } catch (error) {
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: error,
        btn: "กลับ",
      });
      setIsLoading(false);
      return [];
    }
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const addDataJson = (id, selectedId) => {
    const result = bundleProduct(dataJson, products)(id, selectedId);

    setDataJson(result);
  };
  const checkGtokenAccount = async (data) => {
    setIsLoading(true);
    const body = { id_card: idc?.idCard };
    try {
      const res = await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/current_gtoken/selbyidentity`,
        body,
        { headers: { "Content-Type": "application/json" } },
      );
      if (!res?.data?.IsSuccess) {
        if (data.length > 0) {
          const newProductList = findItemById(59, data);
          setProducts(newProductList);
        }
      }
      const isEmp = res?.data.MsgData?.is_employee;
      const isCMKT = res?.data.MsgData?.MktData?.ic_data.some(
        (item) =>
          item.ic_central_aecode === checkuserinfo?.aeCode?.toUpperCase(),
      );
      const gtokenMsg = (!isEmp && res?.data.IsSuccess) || (isEmp && isCMKT);
      if ((isEmp && !isCMKT) || (isEmp && !checkuserinfo?.aeCode)) {
        const newProductList = findItemById(59, data);
        setProducts(newProductList);
      }
      return gtokenMsg;
    } catch (error) {
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: error,
        btn: "กลับ",
      });
    } finally {
      setIsLoading(false);
    }
  };
  const findItemById = (id, data) => {
    const filteredData = data.map((group) => ({
      ...group,
      items: group.items.filter((item) => item.id !== id),
    }));
    return filteredData;
  };
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    const result = chain(products)
      .flatMap((item) => item.items)
      .filter((item) => item.selected === 1 && item.active === 1)
      .map((item) => ({ id: item.id, selected_id: item.selected_id }))
      .value();

    setDataJson(result);
  }, [products]);
  useEffect(() => {
    if (dataJson.length > 0) {
      setIsCheck(true);
    } else {
      setIsCheck(false);
    }
  }, [dataJson]);
  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);

  useEffect(() => {
    const init = async () => {
      const data = await callChoice(); // โหลดข้อมูล
      checkEditUrl();
      checkGtokenAccount(data); // ส่งข้อมูลเข้าเช็ก แล้วให้เช็กเป็นคน setChoices ใหม่ถ้าจำเป็น
    };

    init();
  }, []);

  return (
    <>
      {jumpPage || editUrl ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.product?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/career") : "")}
          />
          <Loading status={isLoading} />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <ProductsType open={isType} btn="ปิด" isModel={setIsType} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.product}
                        clickBack={(e) => props.history.push("/career")}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.product?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid className="font-DBHeavent font-20 text-black">
                                  {translations?.[lang]?.product?.sub_title}
                                </Grid>
                                <Grid>
                                  <Grid className="pt-2 pb-2" container>
                                    <Grid className="font-20 text-primary font-DBHeavent font-weight-bold">
                                      {translations?.[lang]?.product?.type}
                                    </Grid>
                                    <Grid>
                                      <InfoIcon
                                        onClick={() => setIsType(true)}
                                        sx={{
                                          paddingLeft: "10px",
                                          paddingTop: "3px",
                                          color: "var(--lemon)",
                                          fontSize: "20px",
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {products?.map((row, i) => (
                                  <>
                                    {row?.items.length > 0 && (
                                      <Grid key={i}>
                                        <Grid>
                                          <Accordion
                                            expanded={expanded === "panel" + i}
                                            onChange={handleChange("panel" + i)}
                                          >
                                            <AccordionSummary
                                              expandIcon={
                                                <ExpandMoreIcon
                                                  colsor={"primary"}
                                                />
                                              }
                                            >
                                              <Grid className="font-DBHeavent font-20 font-normal pl-4 pt-1 pb-1 fullWidth">
                                                {row?.group}
                                              </Grid>
                                            </AccordionSummary>
                                            <AccordionDetails>
                                              {row?.items?.map((item, j) => (
                                                <Grid
                                                  key={j}
                                                  className="fullWidth"
                                                >
                                                  <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-start"
                                                    alignItems="flex-start"
                                                    className="fullWidth"
                                                  >
                                                    {/* <FormControlLabel
                                                  disabled={
                                                    item.active === 1 ? false : true
                                                  }
                                                  onChange={(e) => {
                                                    addDataJson(
                                                      item.id,
                                                      item.selected_id
                                                    );
                                                  }}
                                                  control={
                                                    <Checkbox
                                                      className={
                                                        item.active === 0 &&
                                                        "chx-disabled"
                                                      }
                                                      checked={
                                                        dataJson.find(
                                                          (e) => e.id === item.id
                                                        )
                                                          ? true
                                                          : false
                                                      }
                                                    />
                                                  }
                                                /> */}
                                                    <Grid item xs={2}>
                                                      <Checkbox
                                                        className={
                                                          item.active === 0 &&
                                                          "chx-disabled"
                                                        }
                                                        checked={
                                                          dataJson.find(
                                                            (e) =>
                                                              e.id === item.id,
                                                          )
                                                            ? true
                                                            : false
                                                        }
                                                        disabled={
                                                          item.active === 1
                                                            ? false
                                                            : true
                                                        }
                                                        onChange={(e) => {
                                                          addDataJson(
                                                            item.id,
                                                            item.selected_id,
                                                          );
                                                        }}
                                                      />
                                                    </Grid>
                                                    <Grid
                                                      item
                                                      xs
                                                      disabled={
                                                        item.active === 1
                                                          ? false
                                                          : true
                                                      }
                                                      onClick={(e) => {
                                                        if (item.active === 1) {
                                                          addDataJson(
                                                            item.id,
                                                            item.selected_id,
                                                          );
                                                        }
                                                      }}
                                                      className={clsx(
                                                        "product-choice-p",
                                                        "font-20 text-black font-DBHeavent",
                                                        item.active === 0 &&
                                                          "chx-disabled",
                                                      )}
                                                    >
                                                      {item?.name}
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              ))}
                                            </AccordionDetails>
                                          </Accordion>
                                        </Grid>
                                      </Grid>
                                    )}
                                  </>
                                ))}
                              </Grid>
                            }
                          />{" "}
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.product?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(ProductsChoice);
